import { Box, Typography } from '@mui/material';
import { LongTwelveHourDateTimeFormat } from '@utils/date';
import { formatInTimeZone } from 'date-fns-tz';

export interface EventDividerProps {
  date: Date;
  text: string; // e.g. an Endorsement was created
  timezone?: string;
}

export const EventDivider = ({ date, text, timezone }: EventDividerProps) => {
  const tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const dateStr = formatInTimeZone(date, tz, LongTwelveHourDateTimeFormat);
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', my: 2, width: '100%', gap: 2 }}>
      <Box sx={{ flex: 1, height: 1, backgroundColor: 'divider' }} />
      <Typography variant='caption' sx={{ whiteSpace: 'nowrap', color: 'text.secondary' }}>
        --- On {dateStr} {text} ---
      </Typography>
      <Box sx={{ flex: 1, height: 1, backgroundColor: 'divider' }} />
    </Box>
  );
};
